const apiUrl = 'http://127.0.0.1:8000';
const douzeroDemoUrl = 'https://aiplatform-ddz-backend.test.gifshow.com';

export { apiUrl, douzeroDemoUrl };
